<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    export let lang = 'pl';
    import { texts } from './texts.js';
    export let decisions;
    export let isGameOn = false;
    export let isGameEnd = false;
    export let isRoundOn = false;
    let allDecided = false;
    let isHurried = false;
    $: allDecided = isEverybodyOk(decisions);
    function isEverybodyOk(obj) {
        for (let prop in obj) {
            if (obj[prop] === 'czekamy') {
                return false;
            }
        }
        return true;
    }
    // $: console.log('hurried:', isHurried);
</script>

<div>
    <h1>{texts[lang].trainer_panel}</h1>
    <p>
        {#if !isGameOn && !isGameEnd}
            <button
                class="message_form_button"
                on:click={() => {
                    dispatch('new-game');
                }}
                disabled={isGameOn || isGameEnd}
                id="new_game">{texts[lang].start_game}</button
            >
        {:else}
            <button
                class="message_form_button"
                on:click={() => {
                    dispatch('new-round');
                }}
                disabled={allDecided === false || !isGameOn || !isRoundOn}
                id="new_round">{texts[lang].end_round}</button
            >

            <button
                class="message_form_button"
                on:click={() => {
                    dispatch('start-round');
                }}
                disabled={!isGameOn || isRoundOn || isGameEnd}
                id="new_round">{texts[lang].start_round}</button
            >
            <button
                class="message_form_button"
                on:click={() => {
                    dispatch('hurry-players');
                }}
                disabled={!isRoundOn || isHurried}
                id="new_round">{texts[lang].hurry_players}</button
            >
        {/if}
    </p>
</div>

<style>
    h1 {
        color: red;
    }
</style>
